/* eslint-disable no-param-reassign */
import { mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';

export default {
  data() {
    return {
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      componentsList: [],
      configGetDataComponent: [
        { page: 1, service: this.getListFormUI },
        { page: 1, service: this.getListMultiFormUI },
        { page: 1, service: this.getListCanvas },
      ],
    };
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionGetDetailForm', 'actionGetDetailMultiForm']),
    ...mapActions('jStoreCanvas', ['getDetailCanvas']),

    getListFormUI(index) {
      if (index !== undefined) {
        this.componentsLibrary[index].loadingSeeMore = true;
        this.configGetDataComponent[index].page = this.configGetDataComponent[index].page + 1;
      }
      const params = {
        limit: 10,
        page: index !== undefined ? this.configGetDataComponent[index].page : 1,
        sort: { updated_at: -1 },
        filter: { company_id: this.session.user.company_id },
      };
      if (this.searchComponent) params.filter.name = this.searchComponent;
      this.actionGetDetailForm(params).then((res) => {
        const data = this._.cloneDeep(res.data);
        const masterComponent = this.list_component_master.find(c => c.name === 'form_ui');
        if (index === undefined && !this.searchComponent) {
          this.componentsList.push({
            section_name: 'Single Experience Manager',
            type: 'single_experience_manager',
            collapse: false,
            useSeeMore: true,
            loadingSeeMore: false,
            hideSeeMore: false,
            components: !res.error ?
              data.map((d) => {
                d.component_type = 'form_ui';
                d.master_component = masterComponent;
                return d;
              }) :
              [],
          });
          this.getListMultiFormUI();
        } else {
          this.componentsLibrary[0].components.push(
            ...data.map((d) => {
              d.component_type = 'form_ui';
              d.master_component = masterComponent;
              return d;
            }),
          );
          this.componentsLibrary[0].loadingSeeMore = false;
          if (this.searchComponent && index === undefined) this.getListMultiFormUI();
          if (data.length < 10) this.componentsLibrary[0].hideSeeMore = true;
          else this.componentsLibrary[0].hideSeeMore = false;
        }
      });
    },

    getListMultiFormUI(index) {
      if (index !== undefined) {
        this.componentsLibrary[index].loadingSeeMore = true;
        this.configGetDataComponent[index].page = this.configGetDataComponent[index].page + 1;
      }
      const params = {
        limit: 10,
        page: index !== undefined ? this.configGetDataComponent[index].page : 1,
        sort: { updated_at: -1 },
        filter: { company_id: this.session.user.company_id },
      };
      if (this.searchComponent) params.filter.name = this.searchComponent;
      this.actionGetDetailMultiForm(params).then((res) => {
        const data = this._.cloneDeep(res.data.data);
        const masterComponent = this.list_component_master.find(c => c.name === 'multiple_form_ui');
        if (index === undefined && !this.searchComponent) {
          this.componentsList.push({
            section_name: 'Multiple Experience Manager',
            type: 'multiple_experience_manager',
            collapse: false,
            useSeeMore: true,
            loadingSeeMore: false,
            hideSeeMore: false,
            components: !res.error ?
              data.map((d) => {
                d.component_type = 'multiple_form_ui';
                d.master_component = masterComponent;
                return d;
              }) :
              [],
          });
          this.getListCanvas();
        } else {
          this.componentsLibrary[1].components.push(
            ...data.map((d) => {
              d.component_type = 'multiple_form_ui';
              d.master_component = masterComponent;
              return d;
            }),
          );
          this.componentsLibrary[1].loadingSeeMore = false;
          if (this.searchComponent && index === undefined) this.getListCanvas();
          if (data.length < 10) this.componentsLibrary[1].hideSeeMore = true;
          else this.componentsLibrary[1].hideSeeMore = false;
        }
      });
    },

    getListCanvas(index) {
      if (index !== undefined) {
        this.componentsLibrary[index].loadingSeeMore = true;
        this.configGetDataComponent[index].page = this.configGetDataComponent[index].page + 1;
      }
      const params = {
        limit: 10,
        page: index !== undefined ? this.configGetDataComponent[index].page : 1,
        filter: { company_id: this.session.user.company_id },
        sort: { updated_at: -1 },
      };
      if (this.searchComponent) params.filter.name = this.searchComponent;
      this.getDetailCanvas(params).then((res) => {
        const data = this._.cloneDeep(res.data.data);
        const masterComponent = this.list_component_master.find(c => c.name === 'canvas');
        if (index === undefined && !this.searchComponent) {
          this.componentsList.push({
            section_name: 'Analytic',
            type: 'canvas',
            collapse: false,
            useSeeMore: true,
            loadingSeeMore: false,
            hideSeeMore: false,
            components: !res.error ?
              data.map((d) => {
                d.component_type = 'canvas';
                d.master_component = masterComponent;
                return d;
              }) :
              [],
          });
          this.setComponentHtml();
        } else {
          this.componentsLibrary[2].components.push(
            ...data.map((d) => {
              d.component_type = 'canvas';
              d.master_component = masterComponent;
              return d;
            }),
          );
          this.componentsLibrary[2].loadingSeeMore = false;
          if (data.length < 10) this.componentsLibrary[2].hideSeeMore = true;
          else this.componentsLibrary[2].hideSeeMore = false;
        }
      });
    },

    setComponentHtml() {
      const masterComponent = this.list_component_master.find(c => c.name === 'html');
      this.componentsList.push({
        section_name: 'HTML',
        type: 'canvas',
        collapse: false,
        useSeeMore: false,
        components: [
          {
            component_type: 'html',
            master_component: masterComponent,
            ...masterComponent,
          },
        ],
      });
      this.setComponentAttendance();
    },

    setComponentAttendance() {
      const masterComponent = this._.cloneDeep(this.list_component_master.filter(c => c.name.includes('attendance')));
      this.componentsList.push({
        section_name: 'Attendance',
        type: 'canvas',
        collapse: false,
        useSeeMore: false,
        components: masterComponent.map(c => ({
          component_type: c.name,
          master_component: c,
          ...c,
        })),
      });
      this.setComponentLeave();
    },

    setComponentLeave() {
      const masterComponent = this._.cloneDeep(this.list_component_master.filter(c => c.name.includes('leave')));
      this.componentsList.push({
        section_name: 'Leave',
        type: 'canvas',
        collapse: false,
        useSeeMore: false,
        components: masterComponent.map(c => ({
          component_type: c.name,
          master_component: c,
          ...c,
        })),
      });
      this.setComponentOvertime();
    },

    setComponentOvertime() {
      const masterComponent = this._.cloneDeep(this.list_component_master.filter(c => c.name.includes('overtime')));
      this.componentsList.push({
        section_name: 'Overtime',
        type: 'canvas',
        collapse: false,
        useSeeMore: false,
        components: masterComponent.map(c => ({
          component_type: c.name,
          master_component: c,
          ...c,
        })),
      });
      this.setComponentTimesheet();
    },

    setComponentTimesheet() {
      const masterComponent = this._.cloneDeep(this.list_component_master.filter(c => c.name.includes('timesheet')));
      this.componentsList.push({
        section_name: 'Timesheet',
        type: 'canvas',
        collapse: false,
        useSeeMore: false,
        components: masterComponent.map(c => ({
          component_type: c.name,
          master_component: c,
          ...c,
        })),
      });
      this.setComponentOthers();
    },

    setComponentOthers() {
      const otherComponents = [
        'hierarchy',
        'custom_hierarchy',
        'user_setup',
        'employee_setup',
        'access_management',
        'embed_url',
      ];
      const masterComponent = this._.cloneDeep(
        this.list_component_master.filter(c => otherComponents.includes(c.name)),
      );
      this.componentsList.push({
        section_name: 'Others',
        type: 'canvas',
        collapse: false,
        useSeeMore: false,
        components: masterComponent.map(c => ({
          component_type: c.name,
          master_component: c,
          ...c,
        })),
      });
      this.componentsLibrary = this._.cloneDeep(this.componentsList);
      this.isLoading = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/app-manager/jMixLayoutDummy.js